import React, { useState } from "react";
import cn from "classnames";
import Icon from "components/CommonIcon/Icon";
import InputFloatLabel from "components/Design/Input/InputFloatLabel";

type InputDateRangePickerProps = {
  startDateLabel: string;
  endDateLabel: string;
  startDateValue: string;
  endDateValue: string;
  startDateClick: () => void;
  endDateClick: () => void;
  fullBorder: boolean;
  withIcon: boolean;
  viewRateBlock?: boolean;
};

const InputDateRangePicker = ({
  startDateLabel,
  endDateLabel,
  startDateValue,
  endDateValue,
  startDateClick,
  endDateClick,
  fullBorder,
  withIcon,
  viewRateBlock,
}: InputDateRangePickerProps) => {
  const [isFocus, setIsFocus] = useState(false);

  return (
    <div
      className={cn("h-full flex flex-nowrap rounded-sm", {
        "border border-gray-light md:border-r-0": fullBorder,
        "input-daterange-withicon-focused": isFocus,
      })}>
      <div
        className={cn("w-full", {
          "border border-r-0 md:border-0 md:border-r border-gray-light":
            !withIcon,
        })}>
        {/* TODO: Remove after converting this to TS */}
        {/* @ts-ignore */}
        <InputFloatLabel
          data-testid="check-in-id"
          label={startDateLabel}
          value={startDateValue}
          onClick={startDateClick}
          noBorder
          className="h-full rounded-sm"
          inputClassName="cursor-pointer"
          readOnly
          floatLabelByDefault
          suffixIcon={withIcon && <div className="w-12 h-1 bg-gray-disable" />}
          setIsFocus={withIcon && setIsFocus}
          name={startDateLabel}
          viewRateBlock={viewRateBlock}
        />
      </div>
      <div
        className={cn("w-full", {
          "border md:border-0 md:border-r border-gray-light": !withIcon,
        })}>
        {/* TODO: Remove after converting this to TS */}
        {/* @ts-ignore */}
        <InputFloatLabel
          data-testid="check-out-id"
          label={endDateLabel}
          value={endDateValue}
          onClick={endDateClick}
          noBorder
          className="h-full rounded-sm"
          inputClassName="cursor-pointer"
          readOnly
          floatLabelByDefault
          suffixIcon={withIcon && <Icon name="calendar" fontSize="text-14" />}
          setIsFocus={withIcon && setIsFocus}
          name={endDateLabel}
          viewRateBlock={viewRateBlock}
        />
      </div>
    </div>
  );
};

export default InputDateRangePicker;
